/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

type Props = {
  data: any
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const TotalMember: FC<Props> = ({
  data,
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  useEffect(() => {
    refreshChart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])
  setTimeout(() => {
    initChart(chartSize, chartLine, chartRotate, data)
  }, 10)
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }


  }

  return (
    <div className={`card card-flush ${className}`} style={{ backgroundColor: '#F1416C', backgroundImage: 'url(https://preview.keenthemes.com/metronic8/demo1/assets/media/patterns/vector-1.png)' }}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'></span>

            {/*<span className='badge badge-light-success fs-base'>
              <KTIcon iconName='arrow-up' className='fs-5 text-success ms-n1' /> 2.2%
  </span>*/}
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>Total User</span>
          <span className='fs-2hx fw-bold me-2 lh-1 ls-n2'>{data.all} คน</span>
        </div>
      </div>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
        <div className='d-flex flex-center me-5 pt-2'>
          <div
            id='kt_card_widget_17_chart'
            ref={chartRef}
            style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
            data-kt-size={chartSize}
            data-kt-line={chartLine}
          ></div>
        </div>

        <div className='d-flex flex-column content-justify-center flex-row-fluid'>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
            <div className='text-white opacity-75 flex-grow-1 me-4'>not verify</div>
            <div className='fw-bolder text-white  text-xxl-end'>{data.register} คน</div>
          </div>
          <div className='d-flex fw-semibold align-items-center my-3'>
            <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
            <div className='text-white opacity-75 flex-grow-1 me-4'>verify</div>
            <div className='fw-bolder text-white  text-xxl-end'>{data.verify} คน</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div
              className='bullet w-8px h-3px rounded-2 me-3'
              style={{ backgroundColor: '#E4E6EF' }}
            ></div>
            <div className='text-white opacity-75 flex-grow-1 me-4'>not register</div>
            <div className=' fw-bolder text-white  text-xxl-end'>{data.notRegister} คน</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const initChart = async function (
  chartSize: number = 70,
  chartLine: number = 11,
  chartRotate: number = 145,
  data: any
) {
  const el = document.getElementById('kt_card_widget_17_chart')
  if (!el) {
    return
  }
  el.innerHTML = ''

  var options = {
    size: chartSize,
    lineWidth: chartLine,
    rotate: chartRotate,
    //percent:  el.getAttribute('data-kt-percent') ,
  }

  const canvas = document.createElement('canvas')
  const span = document.createElement('span')

  // @ts-ignore
  if (typeof G_vmlCanvasManager !== 'undefined') {
    // @ts-ignore
    G_vmlCanvasManager.initElement(canvas)
  }

  const ctx = canvas.getContext('2d')
  canvas.width = canvas.height = options.size

  el.appendChild(span)
  el.appendChild(canvas)

  // @ts-ignore
  ctx.translate(options.size / 2, options.size / 2) // change center
  // @ts-ignore
  ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI) // rotate -90 deg

  //imd = ctx.getImageData(0, 0, 240, 240);
  const radius = (options.size - options.lineWidth) / 2

  const drawCircle = function (color: string, lineWidth: number, percent: number) {
    percent = Math.min(Math.max(0, percent || 1), 1)
    console.log('percent', percent)
    if (!ctx) {
      return
    }

    ctx.beginPath()
    ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false)
    ctx.strokeStyle = color
    ctx.lineCap = 'round' // butt, round or square
    ctx.lineWidth = lineWidth
    ctx.stroke()
  }

  function compareNumbers(a: any, b: any) {
    return b - a
  }

  let sortData = [data.registerPercent, data.verifyPercent, data.notRegisterPercent]
  sortData.sort(compareNumbers)
  let d2 = Number(sortData[1]) + Number(sortData[2])
  let d3 = sortData[2]
  console.log(sortData, d2, d3)
  // Init 2
  // ใส่ percent ตรงนี้
  let dup = 0
  let dupName = ''
  console.log(data)
  await Promise.all(sortData.map((item: any, index: any) => {
    console.log(item)
    if (index == 0) {
      if (item == data.registerPercent && dupName != 'registerPercent') {
        dupName = 'registerPercent'
        drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, 1)
      } else if (item == data.verifyPercent && dupName != 'verifyPercent') {
        dupName = 'verifyPercent'
        drawCircle(getCSSVariableValue('--bs-success'), options.lineWidth, 1)
      } else if (item == data.notRegisterPercent && dupName != 'notRegisterPercent') {
        dupName = 'notRegisterPercent'
        drawCircle('#E4E6EF', options.lineWidth, 1)
      }
    } else if (index == 1) {
      if (item == data.registerPercent && dupName != 'registerPercent') {
        dupName = 'registerPercent'
        console.log('xx')
        drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, d2)
      } else if (item == data.verifyPercent && dupName != 'verifyPercent') {
        dupName = 'verifyPercent'
        console.log('yy', d2)
        drawCircle(getCSSVariableValue('--bs-success'), options.lineWidth, d2)
      } else if (item == data.notRegisterPercent && dupName != 'notRegisterPercent') {
        dupName = 'notRegisterPercent'
        drawCircle('#E4E6EF', options.lineWidth, d3)
      }
    } else if (index == 2) {
      if (item == data.registerPercent && dupName != 'registerPercent') {
        dupName = 'registerPercent'
        drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, d3)
      } else if (item == data.verifyPercent && dupName != 'verifyPercent') {
        dupName = 'verifyPercent'
        drawCircle(getCSSVariableValue('--bs-success'), options.lineWidth, d3)
      } else if (item == data.notRegisterPercent && dupName != 'notRegisterPercent') {
        dupName = 'notRegisterPercent'
        drawCircle('#E4E6EF', options.lineWidth, d3)
      }
    }
  }))
}

export { TotalMember }
